import React from "react"
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { IP2GTheme } from '@parcel2go/peacock-legacy-themes/dist/types';
import { P2GIcon } from "@parcel2go/peacock-legacy-core/dist/icons"
import SvgDuplicate from "@parcel2go/peacock-legacy-core/dist/icons/svg/Duplicate"
import { P2GTooltip } from "@parcel2go/peacock-legacy-core/dist/tooltip"
import { useP2GTranslation } from "@parcel2go/peacock-legacy-resources/dist/translations/hook"
import { P2GLink } from "@parcel2go/peacock-legacy-core";

interface IClipboardProps {
    value: string | number,
    onCopied?: () => void,
    useTooltip?: boolean
}

const useStyles = makeStyles((theme: IP2GTheme) => ({
    icon: {
        opacity: 0.7,
        transition: "opacity .4s ease",
        "&:hover": {
            opacity: 1,
        },
        "& svg": {
            "& path": {
                transition: "fill .4s ease"
            }
        },
        "&.active": {
            "& svg": {
                "& path": {
                    fill: theme.palette.success.main
                }
            }
        }
    },
}));

export const Clipboard: React.FC<IClipboardProps> = (props) => {

    const classes = useStyles();
    const [active, setActive] = React.useState<boolean>(false);
    const title = useP2GTranslation({ translation: "TASK.CLIPBOARD" });

    React.useEffect(() => {
        if (active) {
            const timer = setTimeout(() => {
                setActive(false);
            }, 500);
            return () => clearTimeout(timer);
        }
        return () => { }
    }, [active])

    async function copyTextToClipboard(e: React.MouseEvent<HTMLElement>) {
        e.preventDefault();
        e.stopPropagation();
        await navigator.clipboard.writeText(props.value.toString());
        if (props.onCopied) {
            props.onCopied();
        }
        setActive(true);
    }

    if (!navigator.clipboard) {
        return null;
    }

    if(props.useTooltip){
        return (
            <P2GTooltip title={title}>
                <P2GIcon size="xs" onClick={copyTextToClipboard} classNames={clsx('p2g-clipboard', classes.icon, { "active": active })}>
                    <SvgDuplicate />
                </P2GIcon>
            </P2GTooltip>
        )
    }

    return (
        <P2GTooltip title={title}>
            <P2GLink onClick={copyTextToClipboard} classNames={clsx('p2g-clipboard', classes.icon, { "active": active })}>
                {props.children}
            </P2GLink>
        </P2GTooltip>
    )
}